import { useParams } from 'react-router-dom'
import VisorNoticias from '../components/VisorNoticias.js'

const Noticias = () => {
  const { id } = useParams()
  return <VisorNoticias />
}

export default Noticias
